import { RefUnite } from './ref-unite.model';
import { RefContenant } from './ref-contenant.model';
import { Conditionnement } from './conditionnement.model';
import { Cepage } from './cepage.model';
import { MouvementDestination } from './mouvement-destination.model';
import { RefMouvement } from './ref-mouvement.model';
import { NatureControle } from './nature-controle.model';
import { ObjetControle } from './objet-controle.model';
import { PressionDeclencheur } from './pression-declencheur.model';
import { EchantillonStatut } from './echantillon-statut.model';
import { Campagne } from './campagne.model';
import { TypeControle } from './type-controle.model';
import { StatutControle } from './statut-controle.model';
import { StatutManquement } from './statut-manquement.model';
import { RefMvtTypeVin } from './ref-mvt-type-vin.model';
import { RefMvtDistillationVCI } from './ref-mvt-distillation-vci.model';
import { EnvironnementLabel } from './environnement-label.model';
import { RevendicationType } from '../revendication-type.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Referentiel {
    static jsonMap = {
        refUniteList: { key: 'refUniteList', converter: new (ArrayClassConverterFactory.build(RefUnite))() },
        refContenantList: { key: 'refContenantList', converter: new (ArrayClassConverterFactory.build(RefContenant))() },
        conditionnements: { key: 'refMvtConditionnementList', converter: new (ArrayClassConverterFactory.build(Conditionnement))() },
        cepages: { key: 'refCepageList', converter: new (ArrayClassConverterFactory.build(Cepage))() },
        mouvementsDestinations: { key: 'refMvtDestinationList', converter: new (ArrayClassConverterFactory.build(MouvementDestination))() },
        refMouvements: { key: 'refMouvementList', converter: new (ArrayClassConverterFactory.build(RefMouvement))() },
        naturesControle: { key: 'refControleNatureList', converter: new (ArrayClassConverterFactory.build(NatureControle))() },
        objetsControle: { key: 'refControleObjetList', converter: new (ArrayClassConverterFactory.build(ObjetControle))() },
        statutsControle: { key: 'refControleStatutList', converter: new (ArrayClassConverterFactory.build(StatutControle))() },
        typesControle: { key: 'refControleTypeList', converter: new (ArrayClassConverterFactory.build(TypeControle))() },
        pressionDeclencheurs: { key: 'refPressionDeclencheurList', converter: new (ArrayClassConverterFactory.build(PressionDeclencheur))() },
        echantillonStatuts: { key: 'refEchantillonStatutList', converter: new (ArrayClassConverterFactory.build(EchantillonStatut))() },
        campagnes: { key: 'refCampagneList', converter: new (ArrayClassConverterFactory.build(Campagne))() },
        statutsManquement: { key: 'refManquementStatutList', converter: new (ArrayClassConverterFactory.build(StatutManquement))() },
        refMvtTypesVin: { key: 'refMvtTypeVinList', converter: new (ArrayClassConverterFactory.build(RefMvtTypeVin))() },
        refMvtDistillationVCI: { key: 'refMvtDistillationVciList', converter: new (ArrayClassConverterFactory.build(RefMvtDistillationVCI))() },
        environnementLabels: { key: 'refEnvironnementLabelList', converter: new (ArrayClassConverterFactory.build(EnvironnementLabel))() },
        revendicationTypes: { key: 'refRevendicationTypeList', converter: new (ArrayClassConverterFactory.build(RevendicationType))() }
    };

    refUniteList: RefUnite[];
    refContenantList: RefContenant[];
    conditionnements: Conditionnement[];
    cepages: Cepage[];
    mouvementsDestinations: MouvementDestination[];
    refMouvements: RefMouvement[];
    naturesControle: NatureControle[];
    objetsControle: ObjetControle[];
    statutsControle: StatutControle[];
    typesControle: TypeControle[];
    pressionDeclencheurs: PressionDeclencheur[];
    echantillonStatuts: EchantillonStatut[];
    campagnes: Campagne[];
    statutsManquement: StatutManquement[];
    refMvtTypesVin: RefMvtTypeVin[];
    refMvtDistillationVCI: RefMvtDistillationVCI[];
    environnementLabels: EnvironnementLabel[];
    revendicationTypes: RevendicationType[];
}
